import { type FC, useEffect, useState } from "react";
import { type CategoryListProps } from "@legacy_user_frontend/components/pages/mypage/profiles/credentials_edit/src/credentials_edit_props";
import * as styles from "@legacy_user_frontend/components/pages/mypage/profiles/credentials_edit/src/styles.css";
import { BusinessTypesList } from "./business_types_list";

export const CategoryList: FC<CategoryListProps> = ({ categoryName, jobTypes, isBiyo }) => {
  // アコーディオンの開閉
  const [isOpen, setIsOpen] = useState(false);
  // ケアの場合は介護を開いた状態で表示する
  useEffect(() => {
    if (!isBiyo && categoryName === "介護") {
      setIsOpen(true);
    }
  }, [categoryName, isBiyo]);
  const handleOnClick = () => {
    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };

  return (
    <>
      <dt>
        <button
          type="button"
          onClick={handleOnClick}
          className={styles.categoryAccordionButtonVariant[isOpen ? "open" : "closed"]}
        >
          {categoryName}
        </button>
      </dt>
      <dd>
        <div className={styles.accordionContentVariant[isOpen ? "open" : "closed"]}>
          <ul className={styles.businessTypesList}>
            {jobTypes.map(({ name, credentialItems }) => (
              <BusinessTypesList name={name} credentialItems={credentialItems} key={name} />
            ))}
          </ul>
        </div>
      </dd>
    </>
  );
};
